import { render, staticRenderFns } from "./ModalPeritiAttivi.vue?vue&type=template&id=2b90f064&scoped=true"
import script from "./ModalPeritiAttivi.vue?vue&type=script&lang=js"
export * from "./ModalPeritiAttivi.vue?vue&type=script&lang=js"
import style0 from "./ModalPeritiAttivi.vue?vue&type=style&index=0&id=2b90f064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90f064",
  null
  
)

export default component.exports